import styled from '@emotion/styled';
import { colors } from '@smartsheet/lodestar-core';

export const Title = styled.div`
  font-family: 'TT Norms Pro Bold';
  font-size: 18px;
  line-height: 40px;
  font-weight: 700;
  color: ${colors.neutralDark40};
`;
